import { render } from "./RecreationDetails.vue?vue&type=template&id=052a4383"
import script from "./RecreationDetails.vue?vue&type=script&lang=js"
export * from "./RecreationDetails.vue?vue&type=script&lang=js"

import "./RecreationDetails.vue?vue&type=style&index=0&id=052a4383&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "052a4383"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('052a4383', script)) {
    api.reload('052a4383', script)
  }
  
  module.hot.accept("./RecreationDetails.vue?vue&type=template&id=052a4383", () => {
    api.rerender('052a4383', render)
  })

}

script.__file = "src/components/recreation/RecreationDetails.vue"

export default script